__turbopack_context__.v({
  "className": "notosansarabic_f3890305-module__G-X7Rq__className",
  "variable": "notosansarabic_f3890305-module__G-X7Rq__variable",
});
